import PropTypes from "prop-types";
import { forwardRef, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import FnrFade from "UI/FnrFade/FnrFade";

const SSpan = styled("span")`
  ${({
    theme: {
      colors: { error },
    },
  }) => `color: ${error};`}
`;

const FnrErrorText = forwardRef(
  /**
   *
   * @param {object} param0
   * @param {boolean} param0.error - Should this message display?
   * @param {import("react").Ref} refArg
   */
  ({ error, children, ...rest }, refArg) => {
    const localRef = useRef();
    const ref = refArg || localRef;
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
      setIsMounted(true);
      return () => setIsMounted(false);
    }, []);

    useEffect(() => {
      if (error && children && ref.current) {
        setTimeout(() => {
          if (isMounted && ref.current && ref.current.scrollIntoView)
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300 /* FnrFade animation time is the framer motion default */);
      }
    }, [children, error, isMounted, ref]);

    return (
      <FnrFade ref={ref} show={error} {...rest}>
        <SSpan>{children}</SSpan>
      </FnrFade>
    );
  }
);

FnrErrorText.propTypes = {
  /** set to true to show the error */
  error: PropTypes.bool,
  /** The error to display */
  children: PropTypes.node,
};

export default FnrErrorText;
